module.exports = __webpack_public_path__ + "img/dark-grey.ac0d00da.png";